import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { alcoholReceivedCounselingAddressNameFields } from 'constants/enums/people';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import substanceAlcoholReceivedCounselingItemValidator from './validators/item';
import { SubstanceAlcoholRecievedCounselingModel } from './types';

const substanceAlcoholReceivedCounselingValidator: ValidateJSModel<SubstanceAlcoholRecievedCounselingModel> = {
  ReceivedTreatment: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (attributes?.ReceivedTreatment && attributes?.ReceivedTreatment.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, alcoholReceivedCounselingAddressNameFields);
      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }
      return {
        presence: true,
        ...additionalValidation,
        accordion: { validator: substanceAlcoholReceivedCounselingItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceAlcoholReceivedCounselingValidator;
